import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/legal-pages.css';

const LegalEdgePlanContract: React.FC = () => {
  return (
    <main className="legal-page">
      <div className="container">
        <h1>Legal Edge Plan Contract</h1>
        <p className="intro-notice">
          PLEASE READ THIS CONTRACT BEFORE SUBSCRIBING TO THE{' '}
          <Link to="/legal-edge-plan">LEGAL EDGE PLAN</Link>.
        </p>

        <div className="legal-content">
          <p>
            <em>
              This is a contract between us, GeauxPlans.com, L.L.C. ("GeauxPlans") and you,
              (the "Primary Member"), for the Legal Edge Plan services described below. In
              addition to the GeauxPlans.com, L.L.C. ("GeauxPlans"){' '}
              <Link to="/terms">Terms of Use</Link>, that govern your use of the GeauxPlans
              website (www.geauxplans.com) (the "Website"), this contract (the "Agreement")
              constitutes a legal agreement between you and GeauxPlans detailing the terms
              of your use of the Legal Edge Plan. This Agreement is effective as of the date
              you accept its terms by purchasing a Legal Edge Plan membership (the "Effective
              Date"). If you sign up for a Legal Edge Plan, you accept these terms, conditions,
              limitations, and requirements. Please read this Agreement carefully.
            </em>
          </p>

          <p className="important-notice">
            <strong>
              THE LEGAL EDGE PLAN IS NOT A SUBSTITUTE FOR ACCOUNTING, BUSINESS, TAX, OR OTHER
              PROFESSIONAL ADVICE OR SERVICES.
            </strong>
          </p>

          <h2>1. Legal Edge Plan Membership</h2>
          <p>
            We reserve the right to accept or refuse membership in our discretion. You may not
            transfer or assign your Legal Edge Plan or these benefits.
          </p>

          <h2>2. Benefits of Legal Plans</h2>
          <p>The Legal Plans provide the following benefits.</p>
          <p>
            a. Membership in a Legal Plan provides the following benefits (collectively, the
            "Plan Benefits"):
          </p>
          <ol>
            <li>
              Unlimited revisions to your GeauxPlan Documents at any time and for any reason,
              subject to certain limitations set forth below. GeauxPlans Documents are produced
              and generated by the user. As such, revisions, modifications, or changes are the
              sole responsibility of the Primary Member. Further, it is the sole responsibility
              of the Primary Member to notify GeauxPlans of any changes. GeauxPlans will
              thereafter upload revised documents to the Primary User's dashboard or account
              on the Website.
            </li>
            <li>
              A full 100% credit of your base GeauxPlans fee (exclusive of your Legal Edge Plan
              subscription payments) toward an Advanced Estate Plan prepared by a participating
              or affiliated law firm (the "Firm"); provided, however, the Firm is able to
              undertake representation of the Primary Member without prohibited conflicts of
              interest as set forth in applicable rules of professional conduct of any governing
              state bar association regulating the practice of law. Fees for an Advanced Estate
              Plan prepared by the Firm shall be quoted to the Primary Member after an initial
              consultation between a representative of the Firm and the Primary Member, or his /
              her legal representative. The Firm reserves the right to set fees for any Advanced
              Estate Plan prepared by the Firm. If the Primary Member chooses not to proceed with
              an Advanced Estate Plan prepared by the Firm based on the quoted fee for an Advanced
              Estate Plan or any other reason, the Primary Member shall not be entitled to a
              refund of any fees paid to GeauxPlans, including the original GeauxPlans fee or
              any subscription fees for the Legal Advantage Plan.
            </li>
            <li>
              Once during each membership year, the Primary Member shall be entitled to a check-up
              meeting (the "GeauxPlans Check-Up"). The GeauxPlans Check-Up is intended to provide
              the Primary Member with an (a) assessment of his or her legal profile and
              recommendations based on significant issues or gaps or (b) update of a previous
              GeauxPlans Check-Up considering changes in life, circumstances, legal profile, and
              applicable law. The GeauxPlans Check-Up shall include a telephone, video or in-person
              consultation determined in the sole discretion of the Firm, during normal business
              hours, of up to one-half (1/2) hour to discuss the Primary Member's GeauxPlans
              Documents, potential updates over the previous year, and recommendations. The
              GeauxPlans Check-Up shall become available to a Primary Member only after six (6)
              months of membership in the Legal Plan. The time and location of the GeauxPlans
              Check-Up shall be determined in the discretion of the Firm.
            </li>
          </ol>

          <p>
            b. GeauxPlans Check-up meetings may not include tax-related matters or any other
            legal matters unrelated to the Primary Member's GeauxPlans Documents.
          </p>

          <p>
            c. Nothing in the Legal Edge Plan or this Agreement shall be construed to limit the
            right of a Primary Member to retain, at his or her own expense, an unaffiliated
            attorney. GeauxPlans shall not be obligated to pay for any such services.
          </p>

          <p>
            d. Please note that GeauxPlans does not provide legal services. Attorneys made
            available through the Legal Edge Plan are third-party independent contractors who
            agree to provide legal services directly to you, not through GeauxPlans, via a
            separate retention agreement between you and the attorney. Their contact information
            may be provided as advertising. The attorneys have agreed to provide complimentary,
            thirty-minute consultations related to subject matters about which they represent
            that they are qualified in jurisdictions where they are admitted to practice. A
            conflict check will apply. They may require you to meet at their office or another
            location convenient to them or may require a telephonic consultation. GeauxPlans
            will not select an attorney for you. GeauxPlans makes no guarantees as to the
            substance of the attorney's advice.
          </p>

          <h2>3. Exclusions; Limitations; Conflicts</h2>
          <p>
            a. The following items and matters are specifically excluded from the Legal Edge
            Plan, and are not to be considered or treated as Plan Benefits:
          </p>
          <ol>
            <li>
              Any action that directly or indirectly involves GeauxPlans.com, L.L.C. or any of
              its affiliates, directors, agents, or employees;
            </li>
            <li>
              Any action that directly or indirectly involves any Firm providing legal services
              under the Legal Edge Plan; <em>provided, however,</em> that a Firm may, at its
              sole discretion and risk, represent a Legal Edge Plan Member in a matter in which
              another affiliated Firm is representing another party as legal counsel;
            </li>
            <li>
              For employer-sponsored Legal Edge Plan, any action by a Legal Edge Plan Member of
              such program that directly or indirectly involves his or her employer sponsor;
            </li>
            <li>
              Any adversarial action by a Legal Edge Plan Member that directly or indirectly
              involves any other Legal Edge Plan Member;
            </li>
            <li>
              Any action based on acts or occurrences that are alleged to have occurred or
              conditions that were reasonably anticipated or foreseeable before the Legal Edge
              Plan Member's enrollment that did or may give rise to a lawsuit by or against such
              Legal Edge Plan Member; <em>provided, however,</em> that the Firm may, in its sole
              discretion and at its own risk, disregard this exclusion;
            </li>
            <li>
              Any action that resulted in the prior recruitment or retention by the Legal Edge
              Plan Member of another attorney; <em>provided, however,</em> that the Firm may, in
              its sole discretion and at its sole risk, disregard this exclusion;
            </li>
            <li>
              Any matter involving the laws of jurisdictions outside of the United States or its
              subdivisions;
            </li>
            <li>
              Any appeal to an appellate court (i.e., not a trial court); <em>provided, however,</em>
              that the Firm may, in its sole discretion and at its sole risk, disregard this
              exclusion;
            </li>
            <li>
              Any matter that, in the Firm's opinion, is frivolous in nature or objective; or
            </li>
            <li>
              Any case matter or requested service that is determined by the Firm to lack
              sufficient merit to warrant pursuit, or that the Firm decides has been raised an
              inordinate or unreasonable number of times without a change in circumstances.
            </li>
          </ol>

          <p>
            b. The following items and matters are specifically limitations on the scope of the
            Legal Edge Plan, and are not to be considered or treated as Plan Benefits to prevent
            multiple users of the GeauxPlans platform which is intended for single use:
          </p>
          <ol>
            <li>The Primary Member may not be changed.</li>
            <li>
              The Principal or Mandatary of a GeauxPlans Power of Attorney may not be changed.
            </li>
            <li>
              The Person effecting a Healthcare Directive (a/k/a Living Will) or granting a
              HIPAA Release may not be changed.
            </li>
            <li>The Testator or Testatrix of a GeauxPlans Will may not be changed.</li>
            <li>The Settlor of a GeauxPlans Trust may not be changed.</li>
          </ol>

          <h2>4. Not Insurance</h2>
          <p>
            The Legal Edge Plan offered through GeauxPlans is not a contract of insurance or
            indemnification insurance plan, and is not regulated as such. GeauxPlans is not an
            insurance company and does not guarantee legal representation in every situation.
            The Legal Edge Plan provides GeauxPlans' customers with access to free and paid
            legal services from participating or affiliated Firms. GeauxPlans does not reimburse
            or indemnify any Legal Edge Plan Member or pay any Firm for attorney fees or expenses.
          </p>

          <h2>5. Use</h2>
          <p><strong>a. General Practices.</strong></p>
          <p>
            You acknowledge that GeauxPlans may establish general practices and limits concerning
            use of its Legal Edge Plan, including without limitation the maximum number of
            complimentary attorney consultations you may receive in a given period of time
            related to one or all subjects.
          </p>

          <p><strong>b. Right to Change Practices.</strong></p>
          <p>
            You acknowledge that GeauxPlans reserves the right to change these general practices
            and limits at any time, in its sole discretion, with or without notice. However, you
            have the right to cancel your membership should we materially decrease benefits.
          </p>

          <p><strong>c. Responsibility for Misuse.</strong></p>
          <p>
            You are responsible for all expenses incurred or other actions that may occur through
            your use of a GeauxPlan Document. You must immediately alert us of any fraudulent,
            unauthorized, illegal, or suspicious use of a GeauxPlan, or any other breach of
            security or unauthorized or illegal activity that you reasonably suspect.
          </p>

          <h2>6. Authority to Enter Agreement</h2>
          <p>
            If you are entering into this Agreement on behalf of a company or other legal entity,
            you represent that you have the legal authority to bind such entity to these terms,
            in which case the terms "you" or "your" shall refer to such entity. If you do not
            have such authority or if you do not agree with this Agreement, you may not sign up
            for or use any Legal Edge Plan. If after your purchase we find that you do not have
            authority to bind the entity for which you ordered, you will be personally responsible
            for the obligations in this Agreement and the order you placed, including without
            limitation, the payment obligations. We are not liable for any loss or damage
            resulting from our reliance on any instruction, notice, document or communication,
            reasonably believed by us to be genuine and originating from an authorized
            representative of your company. If there is reasonable doubt about the authenticity
            of any such instruction, notice, document, or communication, we may, but are not
            obliged to, require additional authentication from you.
          </p>

          <h2>7. Payment</h2>
          <p><strong>a. Legal Plan Membership Fees.</strong></p>
          <p>
            You will be charged in accordance with the billing terms in effect at the time of
            your initial purchase unless you are notified of a fee change in accordance with
            "Fee Adjustments" below. For any Legal Edge Plan you purchase that is charged in
            full upon purchase, you agree that for each renewal term for such Legal Edge Plan,
            the amount due for the next term will be due and immediately payable in full as of
            the first day of that renewed term. For each Legal Edge Plan, your charge remains
            for each term no matter if you access the Website during that term. In other words,{' '}
            <strong>
              EVEN IF YOU DO NOT USE THE LEGAL EDGE PLAN BENEFITS OR SPEAK WITH AN ATTORNEY,
              YOU WILL BE RESPONSIBLE FOR ANY PLAN MEMBERSHIP FEES UNTIL YOU CANCEL YOUR
              MEMBERSHIP OR IT IS OTHERWISE TERMINATED.
            </strong>{' '}
            For more information regarding canceling your Legal Edge Plan subscription, see the
            "Termination or Cancellation" section below.
          </p>

          <p><strong>b. Billing.</strong></p>
          <p>
            To allow payment for the initial term of a Legal Edge Plan, valid credit card
            information is due at the time of purchase.
          </p>
          <p>
            If you have purchased an automatic renewing plan from GeauxPlans, your Legal Edge
            Plan subscription will renew automatically at the end of the initial term (the
            "Billing Date") and at the end of each term thereafter unless and until you give
            notice of your intention to terminate your Legal Edge Plan subscription pursuant
            to the terms of this Agreement. If you do not give us notice of such intention,
            your credit card will be charged for the renewal term of your Legal Edge Plan
            subscription on your Billing Date. If your purchase date is on the 29th through
            31st day of any month, your Billing Date for renewals in months with fewer days
            will fall on the last day of the month. GeauxPlans may adjust your Billing Date
            in subsequent renewal periods without notice. This will be reflected by a charge
            to your account on a pro-rated basis according to the number of days that have
            passed since the Billing Date of your latest renewal charge. Unless otherwise
            notified in advance by GeauxPlans pursuant to this Agreement, the renewal charge
            will be equal to the original purchase price for the Legal Plan.
          </p>
          <p>You agree to pay GeauxPlans the fees associated with your Legal Edge Plan subscription.</p>

          <p><strong>c. Notice of Automatic Renewal.</strong></p>
          <p>
            If applicable, we will send a reminder email to the email address of record for your
            account approximately one week before your Billing Date. You acknowledge and agree
            that this notice is provided as a courtesy only, and we are not obligated or required
            to provide such notice. You acknowledge and agree that (i) your failure to read,
            (ii) inability to receive, or (iii) the failure of GeauxPlans to send the email does
            not create any liability on the part of GeauxPlans or any third-party service provider.
          </p>

          <p><strong>d. Attorney Fees.</strong></p>
          <p>
            Fees for non-complimentary attorney services provided pursuant to a Legal Edge Plan
            membership shall be paid directly to the providing Firms. Participating Firms and
            attorneys are not employees or agents of GeauxPlans, and have no financial obligation
            to GeauxPlans.
          </p>

          <h2>8. Fee Adjustments</h2>
          <p>
            GeauxPlans may increase its fees for any Legal Edge Plan membership effective the
            first day of a renewal term by giving you notice of the new fees at least thirty (30)
            days before the beginning of the renewal term. If you do not cancel your membership
            pursuant to Section 9, you shall be deemed to have accepted the new fee for that
            renewal term and any subsequent renewal terms (unless the fees are increased in the
            same manner for a subsequent renewal term). Reductions in fees become effective on
            the next renewal term without any pro rata for the period covered under the prior
            fee schedule.
          </p>

          <h2>9. Termination or Cancellation</h2>
          <p><strong>a. By GeauxPlans.</strong></p>
          <ol>
            <li>
              If payment is not made on the Billing Date, as described in Section 7 above, you
              will have until the one (1) month anniversary of your Billing Date (this grace
              period will be thirty-one (31) days in specified states) to correct the credit
              card information on file and post a payment to your account. If after the
              expiration of this grace period you have not made any payment on your Legal Edge
              Plan membership, your non-payment may result in suspension of service and
              subsequent termination of your Legal Edge Plan membership.
            </li>
            <li>
              Your right to use a Legal Edge Plan membership is subject to any limits established
              by GeauxPlans or by your credit card issuer. If payment cannot be charged to your
              credit card or your charge is returned for any reason, including through a
              chargeback, GeauxPlans reserves the right, in its sole and absolute discretion, to
              suspend or terminate your access and account, thereby terminating this Agreement
              and all obligations of GeauxPlans hereunder. If a charge made to your credit card
              is declined, GeauxPlans may make up to five (5) attempts to bill that card over a
              thirty (30) day period.
            </li>
            <li>
              If you wish to reactivate your account after such termination, there will be no
              setup or reactivation fees; <em>provided, however,</em> accounts terminated for
              non-payment will be reactivated only on receipt of the full amount past due and a
              written request to reinstate the account. When an expired account is reactivated,
              the new term begins on the date of reactivation.
            </li>
          </ol>

          <p><strong>b. By Subscriber.</strong></p>
          <ol>
            <li>
              After you have received this Agreement in your Account Dashboard, you have ten (10)
              days in which to examine it. If during this period you decide that you are not
              satisfied with the Agreement, you may return the Agreement to us and have any
              prepaid amounts refunded. If the Agreement is returned and you have not sought
              legal services pursuant hereto within this time period, the Agreement shall be
              void from the beginning and the parties shall be in the same position as if this
              Agreement had not been issued.
            </li>
            <li>
              You will have the right to cancel your Legal Edge Plan membership by calling our
              Customer Care Center at (855) 213-6300 or by cancelling online through the
              "My Account" portal. After such cancellation, your Legal Edge Plan will remain
              active until the end of then-applicable period.
            </li>
          </ol>

          <p><strong>c. Services after Termination.</strong></p>
          <p>
            After termination of your Legal Edge Plan membership, either by you or by GeauxPlans,
            you will not be able to access the corresponding Legal Edge Plan offerings;{' '}
            <em>provided, however,</em> that any access rights to a Legal Edge Plan granted you
            through a separate channel (e.g., through another Legal Plan membership) will remain
            in full force and effect unless and until separately terminated or cancelled.
          </p>

          <h2>10. Dispute Resolution</h2>
          <p>
            The parties agree to arbitrate all disputes and claims pursuant to the{' '}
            <Link to="/terms">Terms of Service</Link> of GeauxPlans.com, as well as the governing
            law set forth therein. A Legal Edge Plan Member has the right to file a complaint
            with his or her state's bar association concerning the conduct of an affiliated
            attorney under the Legal Edge Plan.
          </p>

          <h2>11. Professional, Independent Attorney Judgment</h2>
          <p>
            Attorneys performing legal services for Legal Edge Plan Members under the terms of
            this Agreement are not agents or employees of GeauxPlans. Any attorney rendering
            legal services to Legal Edge Plan Members under a Legal Edge Plan shall maintain
            the attorney-client relationship with the Legal Edge Plan Member, and is solely
            responsible to the Legal Edge Plan Member for all legal services provided. It is
            within the sole discretion of the attorney to determine whether claims or defenses
            pertaining to any matter under this Agreement present a frivolous or otherwise
            unmeritorious claim or defense. Participating attorneys reserve the right to make
            independent professional judgments regarding such presentations. GeauxPlans will
            in no way influence or attempt to affect the rendering of professional services
            of the participating attorneys.
          </p>

          <h2>12. Internal Revenue Service (IRS) Circular 230 Tax Advice Disclosure</h2>
          <p>
            To ensure compliance with requirements imposed by the IRS under Circular 230, we
            inform you that any U.S. federal tax advice contained in any communication from
            GeauxPlans (including information provided by a Firm or an attorney offering a free
            consultation) is and was not intended or written to be used, and cannot be used,
            for the purpose of (1) avoiding penalties under the Internal Revenue Code or
            (2) promoting, marketing, or recommending to another party any matters addressed
            therein.
          </p>

          <h2>13. Non-English-Speaking Customers</h2>
          <p>
            Non-English translations of these Terms, as well as other terms, conditions, and
            policies, are provided for convenience only. In the event of any ambiguity or
            conflict between translations, the English version is authoritative and controls.
          </p>

          <h2>14. Additional Notices</h2>
          <p>
            Notice to Texas Residents: GeauxPlans' Legal Edge Plan is regulated by the Texas
            Department of Licensing and Regulation, which can be contacted by telephone at
            (800)-803-9202 or by email at{' '}
            <a href="mailto:CS.Legal.Service.Contracts@license.state.tx.us">
              CS.Legal.Service.Contracts@license.state.tx.us
            </a>
            . All Legal Edge Plans are provided and administered by GeauxPlans.com, L.L.C.,
            1902 Jackson Street, Alexandria, LA 71301.
          </p>

          <h2>15. Acknowledgement</h2>
          <p>
            BY SUBSCRIBING TO THE LEGAL EDGE PLAN, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE
            TERMS AND AGREE TO BE BOUND BY THEM.
          </p>

          <p className="updated-date">
            <em>Updated: November 30, 2021</em>
          </p>
        </div>
      </div>
    </main>
  );
};

export default LegalEdgePlanContract;
